import {
  LOGIN,
  AUTH_ERROR,
  AUTH_LOADING,
  RESET_AUTH,
  LOGOUT,
  SET_WS_PARAMS,
  GAUTH_CREDS,
} from "../Actions/types";

const INITIAL_STATE = {
  user: null,
  error: "",
  authParams: null,
  loading: false,
  googleAuth: {
    clientId: null,
    clientSecret: null,
  },
};

let authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
        loading: false,
        error: "",
      };
    case AUTH_LOADING:
      return { ...state, loading: action.payload };
    case AUTH_ERROR:
      return { ...state, error: action.payload };
    case SET_WS_PARAMS:
      return { ...state, authParams: action.payload };
    case GAUTH_CREDS:
      return { ...state, googleAuth: action.payload };
    case RESET_AUTH:
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};
export default authReducer;
